import React, { useEffect, useState } from "react";
import api from "../../services/api";
import "./index.scss";

const URLPreview = ({ link }) => {
  const [onLoad, setOnLoad] = useState(true);

  const [data, setData] = useState({
    isUri: true,
    linkTitle: undefined,
    linkDesc: undefined,
    linkImg: undefined,
    linkFavicon: undefined,
  });
  useEffect(() => {
    if (link) {
      getPreview(link);
    }
  }, [link]);
  const getPreview = async (text) => {
    await api
      .get(`/getURLPreview/`, { params: { url: text } })
      .then((res) => {
        setData(res.data);
        setOnLoad(false);
      })
      .catch((err) => {
        setData({});
        setOnLoad(true);
      });
  };
  const renderImage = () => {
    return data.linkImg ? (
      <img className="img" src={data.linkImg} />
    ) : data.linkFavicon ? (
      <img className="favicon" src={data.linkFavicon} />
    ) : null;
  };
  const renderText = () => {
    return (
      <div style={{ paddingLeft: 5 }}>
        {data.linkTitle && (
          <div>
            <strong className="title">{data.linkTitle}</strong>
          </div>
        )}
        {data.linkDesc && (
          <div>
            <span className="subtitle">{data.linkDesc}</span>
          </div>
        )}
      </div>
    );
  };
  return (
    <>
      {!onLoad ? (
        <a className="urlpreview-container" href={link} target="_black">
          <div>{renderImage()}</div>
          <div>{renderText()}</div>
        </a>
      ) : null}
    </>
  );
};

export default URLPreview;
